import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Load2}          from "@Common/react/load2";
import {scopedState}    from "@Common/react/scoped-state";
import {UseState}       from "@Common/react/use-state";
import {setNestedValue} from "@Common/utils/arr-path";
import {sum}            from "@Common/utils/collections";
import {chain}          from "@Common/utils/fs";

export const DedupeLogic = ({mlIds, item, next}) => cs(
    ["disabled", (_, next) => next(!mlIds || mlIds?.length < 2)],
    ["selected", (_, next) => UseState({
        getInitValue: () => chain(
            item?.selections?.excludeDuplicates ?? false,
            (_) => ({
                saved: _,
                current: _,
            })
        ),
        next,
    })],
    consumeContext("apis"),
    ["data", ({apis, disabled}, next) => Load2({
        disabled,
        _key: JSON.stringify(mlIds),
        fetch: () => {
            return apis.next.mailing.dedupe.getDuplicates(mlIds);
        },
        next,
    })],
    ({selected, data, disabled}) => {
        const quantity = !data.value ? null : sum(data.value, (a) => a.count);
        const selected1 = !!(!disabled && quantity && selected.value.current);
        return next({
            quantity: disabled || !selected.value.current ? 0 : quantity,
            itemEditor: {
                $name: "dedupe",
                changed: selected.value.saved !== selected1,
                prepareSave: (item) => ({
                    newValue: setNestedValue(item, ["selections", "excludeDuplicates"], selected1),
                    onSaved: () => selected.change((s) => ({
                        ...s,
                        saved: selected1,
                    })),
                }),
                valid: disabled || !selected.value.current || !data.loading,
            },
            ui: {
                disabled,
                selected: {
                    ...scopedState(selected, ["current"]),
                    // value: selected1,
                },
                ...(disabled || !data.loading && !quantity) && {
                    selected: {
                        value: false,
                    },
                },
                quantity,
                addresses: data,
            },
        });
    },
);
